import React from 'react';
import { createUseStyles } from 'react-jss';
import liveIconSvgUS from '../icons/live-icon.svg';
import liveIconSvgCN from '../icons/cn-live-icon.svg';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

export default function PlaylistItem(props) {
  const { data, onClick, region } = props;
  const c = useStyles(props);

  // livestream player can detect if playing video is live
  // for simplicity and non playing video to work, consider all m3u8 as live
  const isLive = data.source?.endsWith('.m3u8');

  let liveIcon = liveIconSvgUS
  if (region === 'CN') {
    liveIcon = liveIconSvgCN;
  }

  return (
    <div className={c.container}>
      <div className={c.videoThumbnail} onClick={onClick}>
        {isLive ? <img className={c.liveIcon} src={liveIcon} alt="live icon" /> : <div className={c.playButton}></div>}
        <div className={c.titleContainer}>
          <div className={c.title}>{data.title}</div>
        </div>
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    // this div is required for mobile, or height would not be correct
  },
  videoThumbnail: {
    backgroundImage: props => `url(${props.data.poster})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position: 'relative',
    cursor: 'pointer',
    aspectRatio: '16/9',
    marginRight: 18,
    marginLeft: 18,
    marginBottom: 24,

    '&:hover': {
      transform: 'scale(1.02)',
      filter: 'brightness(110%)'
    },

    '@media(max-width: 960px)': {
      marginRight: 0,
      marginLeft: 0,
      minHeight: 50,
      height: 'unset',
      aspectRatio: '16/9',
    }
  },
  titleContainer: {
    position: 'absolute',
    bottom: 0,
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 50%)',
    width: '100%',
    padding: '14px 16px',
  },
  title: {
    fontFamily: FONT_FAMILY_ROBOTO,
    fontSize: 16,
    lineHeight: '26px',
    fontWeight: 400,
    marginTop: 6,
    marginBottom: 6,
    color: 'white',

    // hide overflow text
    textOverflow: 'ellipsis',
    overflow: 'hidden',

    '@media(max-width: 960px)': {
      lineHeight: '25px',
      letterSpacing: '0.8px',
      marginTop: 0,
      marginBottom: 6,
      whiteSpace: 'nowrap'
    }
  },
  subtitle: {
    fontFamily: FONT_FAMILY_ROBOTO,
    fontSize: 12,
    lineHeight: '13px',
    marginBottom: 10,
    color: 'rgba(172, 172, 172, 1)',

    // hide overflow text
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    '@media(max-width: 960px)': {
      lineHeight: '20px',
      letterSpacing: '1px',
      marginTop: 0,
      marginBottom: 6,
    }
  },
  playButton: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderTop: '14px solid transparent',
    borderBottom: '14px solid transparent',
    borderLeft: '24px solid white',

    // center icon
    margin: 'auto',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,

    '@media(max-width: 960px)': {
      borderTop: '10px solid transparent',
      borderBottom: '10px solid transparent',
      borderLeft: '18px solid white',
    }
  },
  liveIcon: {
    position: 'absolute',
    height: 20,
    top: '10px',
    left: '5px',

    '@media(max-width: 960px)': {
      height: 10,
    }
  }
});
